import { render, staticRenderFns } from "./PurchaseEditLedgers.vue?vue&type=template&id=b82deffc&scoped=true"
import script from "./PurchaseEditLedgers.vue?vue&type=script&lang=ts"
export * from "./PurchaseEditLedgers.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEditLedgers.vue?vue&type=style&index=0&id=b82deffc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82deffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b82deffc')) {
      api.createRecord('b82deffc', component.options)
    } else {
      api.reload('b82deffc', component.options)
    }
    module.hot.accept("./PurchaseEditLedgers.vue?vue&type=template&id=b82deffc&scoped=true", function () {
      api.rerender('b82deffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEditLedgers.vue"
export default component.exports